import { useEffect, RefObject } from 'react';

function useOutsideClickListener(ref: RefObject<HTMLElement>, onClickOutside: () => void) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const clickedElement = event.target as Node;

      if (!ref.current || ref.current.contains(clickedElement)) {
        return;
      }

      // Exclude certain components from the outside click detection
      const drawerComponent = document.getElementById('nextgen-drawer-component');
      if (!drawerComponent) {
        onClickOutside();
      }
    };

    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside]);
}

export { useOutsideClickListener };
